import React, { useState, useEffect } from 'react';
import './Test.css';
import ContactUpdate from './ContactUpdate';
import CB from "./CB";

const TestCards = ({ goBack, savedGeneralData, reportToUpdate, isUpdateMode }) => {
  
  const [showContactForm, setShowContactForm] = useState(false);
  const [showCircuitBreakerForm, setShowCircuitBreakerForm] = useState(false);
 
  const [closePositionData, setClosePositionData] = useState([
    { reference: 'R - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    { reference: 'Y - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    { reference: 'B - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    { reference: 'R - Y', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    { reference: 'Y - B', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    { reference: 'B - R', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
  ]);

  const [openPositionData, setOpenPositionData] = useState([
    { reference: 'R - R\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    { reference: 'Y - Y\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    { reference: 'B - B\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
  ]);

  const [illuminationData, setIlluminationData] = useState([
    { description: 'Door Lamp', status: 'OK' },
    { description: 'Spacer Heater with Thermostat', status: 'OK' },
    { description: 'AUX. Power Socket', status: 'OK' },
  ]);


  useEffect(() => {
 
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
     
        
        
        let testData = {};
        if (reportToUpdate.test_data) {
          if (typeof reportToUpdate.test_data === 'string') {
            try {
              testData = JSON.parse(reportToUpdate.test_data);
            } catch (e) {
            
              testData = {};
            }
          } else {
            testData = reportToUpdate.test_data;
          }
        }
        
        const testFormData = testData.testData || {};
        
       
        
     
        const defaultCloseData = [
          { reference: 'R - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'Y - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'B - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'R - Y', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'Y - B', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'B - R', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
        ];
        
        const defaultOpenData = [
          { reference: 'R - R\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'Y - Y\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'B - B\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
        ];
        
        const defaultIlluminationData = [
          { description: 'Door Lamp', status: 'OK' },
          { description: 'Spacer Heater with Thermostat', status: 'OK' },
          { description: 'AUX. Power Socket', status: 'OK' },
        ];
        
       
        const reverseConvertDictToArray = (convertedData, defaultData) => {
          if (!convertedData || typeof convertedData !== 'object') return defaultData;
          
        
          if (Array.isArray(convertedData)) {
            return convertedData.map((item, idx) => {
              if (typeof item === 'object' && item !== null) {
                return item;
              }
              return defaultData[idx] || defaultData[0] || {};
            });
          }
          
        
          const hasReadingKeys = Object.keys(convertedData).some(key => {
            const value = convertedData[key];
            return value && typeof value === 'object' && (value.reading_1 || Object.keys(value).some(k => k.startsWith('reading_')));
          });
          
          if (hasReadingKeys) {
           
            let maxReading = 0;
            Object.values(convertedData).forEach(value => {
              if (value && typeof value === 'object') {
                Object.keys(value).forEach(key => {
                  if (key.startsWith('reading_')) {
                    const num = parseInt(key.replace('reading_', '')) || 0;
                    maxReading = Math.max(maxReading, num);
                  }
                });
              }
            });
            
          
            const reconstructed = [];
            for (let i = 1; i <= maxReading; i++) {
              const item = {};
              Object.keys(convertedData).forEach(field => {
                const fieldData = convertedData[field];
                if (fieldData && typeof fieldData === 'object' && fieldData[`reading_${i}`] !== undefined) {
                  item[field] = fieldData[`reading_${i}`];
                } else if (fieldData && typeof fieldData === 'object') {
                  
                  const firstValue = Object.values(fieldData)[0];
                  if (firstValue !== undefined) {
                    item[field] = firstValue;
                  }
                } else {
                  item[field] = fieldData;
                }
              });
            
              const defaultItem = defaultData[i - 1] || defaultData[0] || {};
              reconstructed.push({ ...defaultItem, ...item });
            }
            
            return reconstructed.length > 0 ? reconstructed : defaultData;
          }
          
        
          if (convertedData.reading_1 || Object.keys(convertedData).some(k => k.startsWith('reading_'))) {
            const extracted = Object.keys(convertedData)
              .filter(k => k.startsWith('reading_'))
              .sort((a, b) => {
                const numA = parseInt(a.replace('reading_', '')) || 0;
                const numB = parseInt(b.replace('reading_', '')) || 0;
                return numA - numB;
              })
              .map(key => convertedData[key])
              .filter(item => item && typeof item === 'object');
            
            return extracted.length > 0 ? extracted : defaultData;
          }
          
        
          const objectValues = Object.values(convertedData).filter(item => item && typeof item === 'object');
          if (objectValues.length > 0 && objectValues.every(v => !Array.isArray(v))) {
          
            return objectValues;
          }
          
          return defaultData;
        };
        
      
        const extractArrayData = reverseConvertDictToArray;
        
      
        
        const loadedCloseData = extractArrayData(testFormData.closePositionData, defaultCloseData);
        const loadedOpenData = extractArrayData(testFormData.openPositionData, defaultOpenData);
        const loadedIlluminationData = extractArrayData(testFormData.illuminationData, defaultIlluminationData);
        
      
        const closeDataLength = Array.isArray(loadedCloseData) && loadedCloseData.length > 0 
          ? Math.max(loadedCloseData.length, defaultCloseData.length) 
          : defaultCloseData.length;
        
        const processedCloseData = Array.from({ length: closeDataLength }, (_, idx) => {
          const defaultItem = defaultCloseData[idx] || defaultCloseData[0] || {
            reference: '', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ'
          };
          const loadedItem = Array.isArray(loadedCloseData) && loadedCloseData[idx] ? loadedCloseData[idx] : {};
          
        
          return {
            reference: loadedItem.reference || loadedItem.Reference || defaultItem.reference,
            appliedVoltage: loadedItem.appliedVoltage || loadedItem.applied_voltage || loadedItem.AppliedVoltage || defaultItem.appliedVoltage,
            resistanceValue: loadedItem.resistanceValue || loadedItem.resistance_value || loadedItem.ResistanceValue || defaultItem.resistanceValue || '',
            resistanceUnit: loadedItem.resistanceUnit || loadedItem.resistance_unit || loadedItem.ResistanceUnit || defaultItem.resistanceUnit
          };
        });
        
        const openDataLength = Array.isArray(loadedOpenData) && loadedOpenData.length > 0 
          ? Math.max(loadedOpenData.length, defaultOpenData.length) 
          : defaultOpenData.length;
        
        const processedOpenData = Array.from({ length: openDataLength }, (_, idx) => {
          const defaultItem = defaultOpenData[idx] || defaultOpenData[0] || {
            reference: '', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ'
          };
          const loadedItem = Array.isArray(loadedOpenData) && loadedOpenData[idx] ? loadedOpenData[idx] : {};
          
          return {
            reference: loadedItem.reference || loadedItem.Reference || defaultItem.reference,
            appliedVoltage: loadedItem.appliedVoltage || loadedItem.applied_voltage || loadedItem.AppliedVoltage || defaultItem.appliedVoltage,
            resistanceValue: loadedItem.resistanceValue || loadedItem.resistance_value || loadedItem.ResistanceValue || defaultItem.resistanceValue || '',
            resistanceUnit: loadedItem.resistanceUnit || loadedItem.resistance_unit || loadedItem.ResistanceUnit || defaultItem.resistanceUnit
          };
        });
        
        const illuminationDataLength = Array.isArray(loadedIlluminationData) && loadedIlluminationData.length > 0 
          ? Math.max(loadedIlluminationData.length, defaultIlluminationData.length) 
          : defaultIlluminationData.length;
        
        const processedIlluminationData = Array.from({ length: illuminationDataLength }, (_, idx) => {
          const defaultItem = defaultIlluminationData[idx] || defaultIlluminationData[0] || {
            description: '', status: 'OK'
          };
          const loadedItem = Array.isArray(loadedIlluminationData) && loadedIlluminationData[idx] ? loadedIlluminationData[idx] : {};
          
          return {
            description: loadedItem.description || loadedItem.Description || defaultItem.description,
            status: loadedItem.status || loadedItem.Status || defaultItem.status
          };
        });
        
    
        setClosePositionData(processedCloseData);
        setOpenPositionData(processedOpenData);
        setIlluminationData(processedIlluminationData);
        
      
        const testDataToSave = {
          closePositionData: processedCloseData,
          openPositionData: processedOpenData,
          illuminationData: processedIlluminationData
        };
        localStorage.setItem('updateTestFormData', JSON.stringify(testDataToSave));
       
      } catch (error) {
        
     
        setClosePositionData([
          { reference: 'R - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'Y - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'B - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'R - Y', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'Y - B', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'B - R', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
        ]);
        setOpenPositionData([
          { reference: 'R - R\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'Y - Y\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
          { reference: 'B - B\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
        ]);
        setIlluminationData([
          { description: 'Door Lamp', status: 'OK' },
          { description: 'Spacer Heater with Thermostat', status: 'OK' },
          { description: 'AUX. Power Socket', status: 'OK' },
        ]);
      }
    } else {
    
      let dataLoaded = false;
      
      const savedTestData = localStorage.getItem('updateTestFormData');
      if (savedTestData) {
        try {
          const parsedData = JSON.parse(savedTestData);
          
          if (parsedData.closePositionData && Array.isArray(parsedData.closePositionData)) {
            setClosePositionData(parsedData.closePositionData);
            dataLoaded = true;
          }
          if (parsedData.openPositionData && Array.isArray(parsedData.openPositionData)) {
            setOpenPositionData(parsedData.openPositionData);
            dataLoaded = true;
          }
          if (parsedData.illuminationData && Array.isArray(parsedData.illuminationData)) {
            setIlluminationData(parsedData.illuminationData);
            dataLoaded = true;
          }
        } catch (error) {
         
        }
      }
      
      if (!dataLoaded && savedGeneralData?.testData) {
        if (savedGeneralData.testData.closePositionData) 
          setClosePositionData(savedGeneralData.testData.closePositionData);
        if (savedGeneralData.testData.openPositionData) 
          setOpenPositionData(savedGeneralData.testData.openPositionData);
        if (savedGeneralData.testData.illuminationData) 
          setIlluminationData(savedGeneralData.testData.illuminationData);
      }
    }
  }, [isUpdateMode, reportToUpdate]); 


useEffect(() => {

  const testData = {
    closePositionData,
    openPositionData,
    illuminationData
  };
  
  if (closePositionData.length > 0 || openPositionData.length > 0 || illuminationData.length > 0) {
    localStorage.setItem('updateTestFormData', JSON.stringify(testData));
    
  }
}, [closePositionData, openPositionData, illuminationData]);

  const handleClosePositionChange = (index, field, value) => {
  setClosePositionData(prevData => {
    const updatedData = [...prevData];
    updatedData[index] = { ...updatedData[index], [field]: value };
    
  
    const testData = {
      closePositionData: updatedData,
      openPositionData,
      illuminationData
    };
    localStorage.setItem('updateTestFormData', JSON.stringify(testData));

    
    return updatedData;
  });
};

const handleOpenPositionChange = (index, field, value) => {
  setOpenPositionData(prevData => {
    const updatedData = [...prevData];
    updatedData[index] = { ...updatedData[index], [field]: value };
    
 
    const testData = {
      closePositionData,
      openPositionData: updatedData,
      illuminationData
    };
    localStorage.setItem('updateTestFormData', JSON.stringify(testData));
 
    
    return updatedData;
  });
};

const handleIlluminationChange = (index, value) => {
  setIlluminationData(prevData => {
    const updatedData = [...prevData];
    updatedData[index] = { ...updatedData[index], status: value };
    
  
    const testData = {
      closePositionData,
      openPositionData,
      illuminationData: updatedData
    };
    localStorage.setItem('updateTestFormData', JSON.stringify(testData));
   
    
    return updatedData;
  });
};
  const validateResistanceInput = (value) => {
    return value.replace(/[^0-9.<>]/g, '');
  };
 
  const handleNextClick = () => {
  
    const testData = {
      closePositionData,
      openPositionData,
      illuminationData
    };
    localStorage.setItem('updateTestFormData', JSON.stringify(testData));
    
    setShowContactForm(true);
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  const handleBackClick = () => {
   
    const testData = {
      closePositionData,
      openPositionData,
      illuminationData
    };
    localStorage.setItem('updateTestFormData', JSON.stringify(testData));
    
    if (goBack) {
     
      goBack();
    } else {
      setShowCircuitBreakerForm(true);
    }
  };
 
  if (showCircuitBreakerForm) {
    return <CB />;
  }

  if (showContactForm) {
    return <ContactUpdate 
      goBack={() => setShowContactForm(false)} 
      savedGeneralData={{
        ...savedGeneralData,
        testData: {
          closePositionData,
          openPositionData,
          illuminationData
        }
      }}
      reportToUpdate={reportToUpdate}
      isUpdateMode={isUpdateMode}
    />;
  }
 
  return (
    <div className="T1" style={{ overflowY: 'auto', maxHeight: '90vh' }}>
      <span className="T2" onClick={redirectToHome}>X</span>

      <div className="T3">
        <div className="T4">
          <div className="T5">
            <h2>INSULATION RESISTANCE TEST</h2>
          </div>

          <div className="T6">
            <div className="T7">
              <h3 className="T8">Breaker Position : CLOSE</h3>
              <div className="T9">
                <table className="T10">
                  <thead>
                    <tr>
                      <th>Reference</th>
                      <th>Applied DC Voltage (V)</th>
                      <th className="T11">Measured Resistance (Ω)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {closePositionData && Array.isArray(closePositionData) && closePositionData.length > 0 ? closePositionData.map((item, index) => (
                      <tr key={index}>
                        <td className="T12">{item?.reference || ''}</td>
                        <td>
                          <select
                            className="T13"
                            value={item?.appliedVoltage || '250V'}
                            onChange={(e) =>
                              handleClosePositionChange(index, "appliedVoltage", e.target.value)
                            }
                          >
                            <option value="250V">250V</option>
                            <option value="500V">500V</option>
                            <option value="1000V">1000V</option>
                            <option value="2500V">2500V</option>
                            <option value="5000V">5000V</option>
                          </select>
                        </td>
                        <td className="T14">
                          <input
                            type="text"
                            className="T15"
                            value={item?.resistanceValue || ''}
                            onChange={(e) => {
                              const validValue = validateResistanceInput(e.target.value);
                              handleClosePositionChange(index, "resistanceValue", validValue);
                            }}
                            placeholder="Value"
                          />
                          <select
                            className="T16"
                            value={item?.resistanceUnit || 'MΩ'}
                            onChange={(e) =>
                              handleClosePositionChange(index, "resistanceUnit", e.target.value)
                            }
                          >
                            <option value="Ω">Ω</option>
                            <option value="KΩ">KΩ</option>
                            <option value="MΩ">MΩ</option>
                            <option value="GΩ">GΩ</option>
                            <option value="TΩ">TΩ</option>
                          </select>
                        </td>
                      </tr>
                    )) : (
                      <tr><td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>No data available. Please wait while data loads...</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="T7">
              <h3 className="T8">Breaker Position : OPEN</h3>
              <div className="T9">
                <table className="T10">
                  <thead>
                    <tr>
                      <th>Reference</th>
                      <th>Applied DC Voltage (V)</th>
                      <th className="T11">Measured Resistance (Ω)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {openPositionData && Array.isArray(openPositionData) && openPositionData.length > 0 ? openPositionData.map((item, index) => (
                      <tr key={index}>
                        <td className="T12">{item?.reference || ''}</td>
                        <td>
                          <select
                            className="T13"
                            value={item?.appliedVoltage || '250V'}
                            onChange={(e) =>
                              handleOpenPositionChange(index, "appliedVoltage", e.target.value)
                            }
                          >
                            <option value="250V">250V</option>
                            <option value="500V">500V</option>
                            <option value="1000V">1000V</option>
                            <option value="2500V">2500V</option>
                            <option value="5000V">5000V</option>
                          </select>
                        </td>
                        <td className="T14">
                          <input
                            type="text"
                            className="T15"
                            value={item?.resistanceValue || ''}
                            onChange={(e) => {
                              const validValue = validateResistanceInput(e.target.value);
                              handleOpenPositionChange(index, "resistanceValue", validValue);
                            }}
                            placeholder="Value"
                          />
                          <select
                            className="T16"
                            value={item?.resistanceUnit || 'MΩ'}
                            onChange={(e) =>
                              handleOpenPositionChange(index, "resistanceUnit", e.target.value)
                            }
                          >
                            <option value="Ω">Ω</option>
                            <option value="KΩ">KΩ</option>
                            <option value="MΩ">MΩ</option>
                            <option value="GΩ">GΩ</option>
                            <option value="TΩ">TΩ</option>
                          </select>
                        </td>
                      </tr>
                    )) : (
                      <tr><td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>No data available. Please wait while data loads...</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="T4">
          <div className="T5">
            <h2>ILLUMINATION / HEATING CKT CHECK</h2>
          </div>

          <div className="T6">
            <div className="T9 T17">
              <table className="T10">
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {illuminationData && Array.isArray(illuminationData) && illuminationData.length > 0 ? illuminationData.map((item, index) => (
                    <tr key={index}>
                      <td className="T18">{item?.description || ''}</td>
                      <td>
                        <select
                          className={`T13 ${item?.status === "OK" ? "T19" : "T20"}`}
                          value={item?.status || 'OK'}
                          onChange={(e) => handleIlluminationChange(index, e.target.value)}
                        >
                          <option value="OK">OK</option>
                          <option value="Not OK">Not OK</option>
                        </select>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="2" style={{ textAlign: 'center', padding: '20px' }}>No data available. Please wait while data loads...</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="T21">
        <button className="T22" onClick={handleBackClick}>Back</button>
        <button className="T23" onClick={handleNextClick}>Next</button>
      </div>
    </div>
  );
};

export default TestCards;